export default __webpack_public_path__ + "static/media/img2.8e83146a.PNG";